<span class="crowdctrl-back-button__stack">
  @if (toolbarPending) {
    <ion-spinner
      class="crowdctrl-back-button__spinner"
      name="crescent"
      aria-label="Navigating"
    ></ion-spinner>
  }
  <ion-back-button
    [class.crowdctrl-back-button--under-spinner]="toolbarPending"
    [attr.slot]="slotAttr"
    [defaultHref]="defaultHref"
    [icon]="backButtonIcon ?? undefined"
    [disabled]="toolbarPending || backButtonDisabled"
  ></ion-back-button>
</span>
